export const verifyFieldNames = {
    basicDetailsStatus: 'basicDetailsStatus',
    legalInfoStatus: 'legalInfoStatus',
    addressDetailsStatus: 'addressDetailsStatus',
    idVerificationStatus: 'idVerificationStatus',
    bssDetailsStatus: 'bssDetailsStatus',
    profileVerifyStatus: 'profileVerifyStatus'
} as const;


export const verifyStatus = {
    not_submitted: "not_submitted",
    incomplete: "incomplete", // descarded
    submitted: "submitted",
    verified: "verified",
    rejected: "rejected",
    not_required: "not_required",
    action_required: "action_required",
    inelijable:"ineligible"
} as const;
